export default __webpack_public_path__ + "static/media/prod-img-9.b9d2ba28.webp";